import React from 'react';
import './Custom-Count.Box.scss';

const CustomCountBox = (props) => {
  const {
    count,
    className = '',
    disableIcon = false,
    customBoxSmall = false,
    showNotification = false,
    onClick,
    borderColor = {},
  } = props;

  const isCheckInToday = count.name === 'Check-In Today';
  const isCheckOuts = count.name === 'Check-Outs';
  const isSpecialCount = isCheckInToday || isCheckOuts;

  return (
    <div
      className={`countbox-wrapper ${
        customBoxSmall ? 'count-box-small' : 'count-box'
      } ${className} ${isSpecialCount ? 'check-in-today' : ''} `}
      onClick={onClick}
      style={borderColor}
    >
      {showNotification && <div className='notification-indicator'></div>}
      <div className='h-100 d-flex align-items-center'>
        <div className={'d-flex align-items-center h-100 g-0 col-12 justify-content-start'}>
          {!disableIcon && (
            <div className={`col left-icon ${isSpecialCount ? 'col-md-4' : 'col-md-6'}`}>
              <div className='image-background' style={{ backgroundColor: count?.color }}>
                <img src={count?.icon} alt={count?.name} />
              </div>
            </div>
          )}
          <div className={`col  ${isSpecialCount ? 'col-md-4 count-with-border' : 'col-md-6'}`}>
            <div className='count-number ps-2 text-wrap' style={{ color: count?.countColor }}>
              {count?.count}
            </div>
            <div className='count-title ps-2 text-wrap'>{count?.name}</div>
          </div>

          {isSpecialCount && (
            <>
              <div className='col subcounts'>
                <div className='completed-count'>
                  <img
                    className='subcount-icon'
                    src={'./assets/icons/dashboard/success.svg'}
                    alt={'completed'}
                  />
                  Completed: {count?.completedCount}
                </div>
                <div className='pending-count'>
                  {' '}
                  <img
                    src={'./assets/icons/dashboard/clock.svg'}
                    alt={'pending'}
                    className='subcount-icon'
                  />
                  Pending: {count?.pendingCount}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomCountBox;
